import React,{useState} from 'react'
import './Imageslider.css'
import {FaArrowAltCircleRight,FaArrowAltCircleLeft} from 'react-icons/fa'

export default function Imageslider(props) {
  const [current,setCurrent] = useState(0)
  const length = props.photos.length

  if(!Array.isArray(props.photos) || length <= 0){
    return null
  }

  const nextSlide = () =>{
    setCurrent(current===length-1 ? 0: current + 1)
  }

  const prevSlide = () =>{
    setCurrent(current===0? length-1:current-1)
  }

  return (
    <section className='slider'>
    <FaArrowAltCircleLeft className="left-arrow" onClick={prevSlide}/>
    <FaArrowAltCircleRight className="right-arrow" onClick={nextSlide}/>
    {
    props.photos.map((photo, index)=>{
      return(
        <div className={index===current?'slide active' : 'slide'} key={index}>
        {index===current && (
          <img src={photo} alt={index} className="slide-image"/>
        )}
        </div>
      )
    })
    }
    </section>
  )
}
